import moment from "moment";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { generarPDF } from "../../../../componentes/imprimir/GenerarPDF";
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { formatoMoneda } from "../../../../configuracion/validaciones";

export const ImprimirInventario = (inventario, soloProducto = false) => {
  if (!inventario) return;

  const { id, fecha, estado, inventarioDetalles = [], Usuario } = inventario;
  const fechaHora = moment(fecha).format("DD-MM-YYYY HH:mm:ss");
  const responsableConteo = Usuario?.Empleados?.[0]?.nombreCorto || "N/A";

  let totalCierre = 0;
  let totalSobrante = 0;
  let totalFaltante = 0;
  let itemsParaRenderizar = [];

  if (soloProducto) {
    const agrupar = inventarioDetalles.reduce((acc, item) => {
      const pId = item.productoId;
      if (!acc[pId]) {
        acc[pId] = {
          ...item,
          existenciaSistema: 0,
          existenciaActual: 0,
          balance: 0,
          cierre: 0,
        };
      }
      acc[pId].existenciaSistema += parseFloat(item.existenciaSistema) || 0;
      acc[pId].existenciaActual += parseFloat(item.existenciaActual) || 0;

      const subBalance = (parseFloat(item.existenciaActual) || 0) - (parseFloat(item.existenciaSistema) || 0);
      const subCierre = subBalance * (parseFloat(item.costo) || 0);

      acc[pId].balance += subBalance;
      acc[pId].cierre += subCierre;
      return acc;
    }, {});
    itemsParaRenderizar = Object.values(agrupar);
  } else {
    itemsParaRenderizar = inventarioDetalles;
  }

  const itemsHTML = itemsParaRenderizar.map((item) => {
    const p = item.producto || {};
    const lote = item.lote || {};
    const loteInventario = item.loteinventario || {};
    const inventarioTipo = loteInventario.inventarioTipo || {};

    const existenciaSistema = parseFloat(item.existenciaSistema) || 0;
    const existenciaActual = parseFloat(item.existenciaActual) || 0;
    const balance = soloProducto ? item.balance : existenciaActual - existenciaSistema;
    const costo = parseFloat(item.costo) || 0;
    const cierre = soloProducto ? item.cierre : balance * costo;

    if (cierre > 0) totalSobrante += cierre;
    else if (cierre < 0) totalFaltante += cierre;
    totalCierre += cierre;

    return `
      <div style="margin-bottom:10px; padding-bottom:5px; border-bottom:1px solid #ccc;">
        <div style="font-weight:bold; font-size:15px;">${p.nombre || "—"}</div>
        <div style="font-size:12px; margin-bottom: 5px;">
          <span><strong>Código:</strong> ${p.codigo || "—"}</span><br/>
          ${!soloProducto ? `<span><strong>Lote:</strong> ${lote.nombre_lote || "—"}</span><br/>
          <span><strong>Ubicación:</strong> ${inventarioTipo.nombre || "—"}</span>` : '<span><strong>Detalle:</strong> Consolidado por producto</span>'}
        </div>
        <div style="display:flex; justify-content:space-between; font-size:13px;">
          <span><strong>Sistema:</strong> ${existenciaSistema}</span>
          <span><strong>Actual:</strong> ${existenciaActual}</span>
          <span><strong>Diferencia:</strong> <span style="color:${balance > 0 ? 'green' : balance < 0 ? 'red' : 'black'};">${balance}</span></span>
        </div>
        <div style="display:flex; justify-content:space-between; font-size:13px;">
          <span><strong>Costo Unitario:</strong> ${formatoMoneda(costo)}</span>
          <span><strong>Cierre:</strong> <span style="color:${cierre > 0 ? 'green' : cierre < 0 ? 'red' : 'black'};">${formatoMoneda(cierre)}</span></span>
        </div>
      </div>`;
  }).join("");

  const entero = Math.abs(Math.trunc(totalCierre));
  const centavos = Math.round(Math.abs(totalCierre) * 100) % 100;
  let textoCierre = NumeroALetras(entero);
  if (centavos > 0) textoCierre += ` CON ${NumeroALetras(centavos)} CENTAVOS`;
  if (totalCierre < 0) textoCierre = `MENOS ${textoCierre}`;

  const html = `
    <div style="width:100%; font-family:'Arial', sans-serif; font-size:14px; color:black; padding:0; margin:0;">
      <img src=${NegocioConfig.logo} style="width:100px; height:100px; display:block; margin:0 auto; padding:0; border:0;" alt="Logo" />
      <div style="text-align:center; margin-bottom:5px;">
        <div style="font-weight:bold; font-size:16px;">${NegocioConfig.nombre}</div>
        <div style="font-size:12px;">RTN: ${NegocioConfig.rtn}</div>
        <div style="font-size:12px;">${NegocioConfig.direccion}</div>
        <div style="font-size:12px;">Tel: ${NegocioConfig.telefono}</div>
        <div style="font-weight:bold; margin:5px 0;">INVENTARIO No. ${id} ${soloProducto ? '(RESUMEN)' : ''}</div>
        <div><strong>Fecha:</strong> ${fechaHora}</div>
        <div><strong>Responsable:</strong> ${responsableConteo}</div>
        <div><strong>Estado:</strong> <span style="color:${estado === "Anulada" ? "red" : "green"}; font-weight:bold;">${estado}</span></div>
      </div>
      <hr style="border:1px dashed black;" />
      <div style="margin-top:5px;">${itemsHTML}</div>
      <hr style="border:1px dashed black;" />
      <div style="text-align:right;">
        <div style="font-size:13px;"><strong>Sobrante:</strong> <span style="color:green;">${formatoMoneda(totalSobrante)}</span></div>
        <div style="font-size:13px;"><strong>Faltante:</strong> <span style="color:red;">${formatoMoneda(Math.abs(totalFaltante))}</span></div>
        <div style="margin-top:4px; font-size:14px; font-weight:bold;">Total Cierre: ${formatoMoneda(totalCierre)}</div>
        <div style="margin-top:4px; font-weight:bold; font-size:12px; text-transform:uppercase;">${textoCierre} LEMPIRAS</div>
      </div>
    </div>
  `;

  const nombreBase = `Comprobante_Inventario_${id}`;
  ImprimirEnIframe(html, nombreBase, '5px');
  generarPDF(html, `${nombreBase}.pdf`, 70);
};